export {
  usePasscodeProtector,
  clearPasscodeCache,
  addToPasscodeCache,
  isBarberPasscodeValidated,
} from './usePasscodeProtector';
export type { UsePasscodeProtectorReturn } from './usePasscodeProtector';
export type * from './types';
